module.exports = __webpack_public_path__ + "../public/img/Atencao.1ead4a71.svg";